import { prefixerC } from './common'

export const ROUTE_PRECIO_RUTA = prefixerC('precio-ruta')
